import React from "react";
import { ChangeEvent } from "react";
import { Link } from "react-router-dom";

import DelayInput from "../DelayInput";

import { apiGet } from "../../Api";
import { formatName } from "../../Utilities";
import withTitle from "../withTitle";


interface IMetricsEmployeesViewState {
    isLoading: boolean | string;
    searchText: string;

    filteredEmployees: any[];
}

class MetricsEmployeesView extends React.Component<{}, IMetricsEmployeesViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            isLoading: true,
            searchText: "",

            filteredEmployees: []
        };

        this.handleSearch = this.handleSearch.bind(this);
        this.search = this.search.bind(this);
    }

    public componentDidMount() {
        this.search();
    }

    public render() {
        return (
            <div className="viewer-root">
                <div className="filter-control-box">
                    <DelayInput type="search" className="fill-space" placeholder="Search..." timeout={300} onChangeDelayed={this.handleSearch} />
                </div>
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th className="col-smallest" />
                        </tr>
                    </thead>
                    <thead className="table-vertical-head-small">
                        <tr>
                            <th>Employees</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.isLoading ?
                                <tr>
                                    <td colSpan={10}>
                                        {
                                            typeof this.state.isLoading === "string"
                                                ? <span className="error-text">{this.state.isLoading}</span>
                                                : <div className="spinner-center lds-dual-ring" />
                                        }
                                    </td>
                                </tr>
                                : this.state.filteredEmployees.map(a => (
                                    <tr key={a.id}>
                                        <td data-caption="Name: ">{formatName(a.name)}</td>
                                        <td>
                                            <Link to={`/metrics/employees/${a.id}`} className="button small text-with-icon">
                                                <span>Details</span>
                                                <i className="icon-chevron-right" />
                                            </Link>
                                        </td>
                                    </tr>
                                ))
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    private handleSearch(e: ChangeEvent<HTMLInputElement>) {
        const value = e.currentTarget.value;

        this.setState({
            searchText: value
        }, () => this.search());
    }

    private async search() {
        const { searchText } = this.state;

        try {
            this.setState({
                isLoading: true
            });

            const employees = this.filterList(await apiGet<any[]>(`employees/summary?q=${searchText}`), searchText);

            this.setState({
                filteredEmployees: employees,
                isLoading: false
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message
            })
        }
    }

    private filterList(list: any[], searchText: string) {
        searchText = searchText.toLowerCase();

        return list.filter(a =>
            a.name.first.toLowerCase().includes(searchText) ||
            a.name.last.toLowerCase().includes(searchText)
        );
    }
}

export default withTitle("Employee Metrics", MetricsEmployeesView);
